export default {"src":"/_next/static/media/camel.a811b54b.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};